function isPlainObject(value) {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}

export function normalizeParsedPair(pair) {
  return {
    id: pair.id,
    questionRaw: pair.questionRaw || '',
    answerRaw: pair.answerRaw || '',
    parseConfidence: pair.parseConfidence || 0,
    parseWarnings: pair.parseWarnings || [],
    isRemoved: Boolean(pair.isRemoved),
    editedByUser: Boolean(pair.editedByUser),
  };
}

export function normalizeFaqDraft(draft, index) {
  if (!isPlainObject(draft)) {
    return {
      id: `faq_draft_${index + 1}`,
      sourcePairIds: [],
      question: '',
      answer: '',
      questionVariants: [],
      tags: [],
      priority: 0,
      confidence: 'medium',
      suggestionType: 'keep',
      suggestionReason: '',
      editedByUser: false,
    };
  }

  return {
    id: draft.id || `faq_draft_${index + 1}`,
    sourcePairIds: Array.isArray(draft.sourcePairIds) ? draft.sourcePairIds : [],
    question: draft.question || '',
    answer: draft.answer || '',
    questionVariants: Array.isArray(draft.questionVariants)
      ? draft.questionVariants
      : [],
    tags: Array.isArray(draft.tags) ? draft.tags : [],
    priority: Number.isFinite(draft.priority) ? draft.priority : 0,
    confidence: draft.confidence || 'medium',
    suggestionType: draft.suggestionType || 'keep',
    suggestionReason: draft.suggestionReason || '',
    editedByUser: Boolean(draft.editedByUser),
  };
}

export function normalizeStyleCandidate(candidate, index) {
  if (!isPlainObject(candidate)) {
    return {
      id: `style_${index + 1}`,
      name: `Phong cách ${index + 1}`,
      description: '',
      sampleReply: '',
      keyPhrases: [],
      confidence: 0,
    };
  }

  return {
    id: candidate.id || `style_${index + 1}`,
    name: candidate.name || `Phong cách ${index + 1}`,
    description: candidate.description || '',
    sampleReply: candidate.sampleReply || '',
    keyPhrases: Array.isArray(candidate.keyPhrases)
      ? candidate.keyPhrases
      : [],
    confidence:
      typeof candidate.confidence === 'number' ? candidate.confidence : 0,
  };
}

export function normalizeAnalyzeResponse(data = {}) {
  return {
    faqDrafts: Array.isArray(data.faqDrafts) ? data.faqDrafts : [],
    styleCandidates: Array.isArray(data.styleCandidates)
      ? data.styleCandidates
      : [],
    configDraft: isPlainObject(data.configDraft) ? data.configDraft : {},
    fieldConfidenceMap: isPlainObject(data.fieldConfidenceMap)
      ? data.fieldConfidenceMap
      : {},
    analysisSummary: isPlainObject(data.analysisSummary)
      ? data.analysisSummary
      : {},
  };
}

export function buildApplyPayload({
  companyId,
  faqDrafts,
  configDraft,
  selectedStyleCandidateId,
  appliedBy,
}) {
  return {
    companyId,
    faqDrafts,
    configDraft,
    selectedStyleCandidateId,
    appliedBy,
  };
}
